/* Generated by oats-generator */

/* eslint-disable @typescript-eslint/interface-name-prefix */

import { APIClient } from '../api';
import { RequestConfig } from '../api/http';

export interface ActivationEngineModel {
    areaPhase?: string | null;
    customerJourneyPhase?: string | null;
    constructionNumberIds?: string[] | null;
}

export interface AddressLight {
    street?: string | null;
    number?: string | null;
    numberSuffix?: string | null;
    postalCode?: string | null;
    city?: string | null;
}

export interface ApartmentBuildingModel {
    areaProjectId?: string | null;
    projectPhaseId?: string | null;
    projectPhaseName?: string | null;
    displayName?: string | null;
    alias?: string | null;
    nodeId?: string | null;
    propertyTypeIds?: string[] | null;
    constructionNumberIds?: string[] | null;
    image?: ResourceModel;
    geometry?: PolygonModel[] | null;
    views?: ApartmentBuildingView[] | null;
    id: string;
}

export interface ApartmentBuildingView {
    id?: string | null;
    imageUrl?: string | null;
    type?: string | null;
    sourceUrl?: string | null;
    label?: string | null;
    buttonLabel?: string | null;
    rotateLeftViewId?: string | null;
    rotateRightViewId?: string | null;
    pointers?: ApartmentBuildingViewPointer[] | null;
}

export interface ApartmentBuildingViewPointer {
    type?: string | null;
    coordinates?: number[] | null;
    constructionNumberId?: string | null;
    linkToViewId?: string | null;
    label?: string | null;
    alignment?: string | null;
    compassDirection?: string | null;
}

export interface AreaProjectModel {
    name?: string | null;
    shortDescription?: string | null;
    regionId?: string | null;
    countryName?: string | null;
    municipalityName?: string | null;
    url?: string | null;
    isSingleProject?: boolean;
    isCompleted?: boolean;
    status?: AreaStatus;
    image?: ResourceModel;
    location?: number[] | null;
    geometry?: PolygonModel[] | null;
    sustainabilitySubjects?: string[] | null;
    sustainabilityInfoText?: string | null;
    mapboxDatasetId?: string | null;
    mapboxTilesetId?: string | null;
    caseViaEmail?: boolean;
    website?: WebsiteModel;
    id: string;
}

export type AreaStatus = 'InPreparation' | 'OnSale' | 'Sold';

export type CRSType = 'unspecified' | 'name' | 'link';

export interface CaseFormModel {
    areaProjectId?: string | null;
    districtId?: string | null;
    projectId?: string | null;
    propertyTypeId?: string | null;
    regionId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    lastNamePrefix?: string | null;
    email: string;
    message: string;
    contactReason?: string | null;
    phoneNumber?: string | null;
    webcareSubject?: string | null;
    complaintCategory?: string | null;
    chatUrl?: string | null;
    mailTo?: string | null;
    referringUrl?: string | null;
}

export interface CityModel {
    countryId?: string | null;
    countryIsoCode?: string | null;
    provinceId?: string | null;
    name?: string | null;
    municipalityName?: string | null;
    seoText?: SeoText;
    id: string;
}

export interface ConstructionNumberLight {
    id?: string | null;
    propertyId?: string | null;
    propertyName?: string | null;
    number?: string | null;
    specification?: string | null;
    description?: string | null;
    status?: string | null;
    underConstruction?: boolean;
    salesPrice?: number | null;
    priceCondition?: string | null;
    priceType?: string | null;
    livingArea?: number | null;
    volume?: number | null;
    lotArea?: number | null;
    plotArea?: number | null;
    numberOfRooms?: number | null;
    numberOfBedooms?: number | null;
    address?: AddressLight;
    gardens?: GardenLight[] | null;
    mainFloorNumber?: string | null;
    floors?: FloorLight[] | null;
}

export interface ConstructionNumberModel {
    areaProjectId?: string | null;
    districtId?: string | null;
    projectPhaseId?: string | null;
    bisproNumber?: string | null;
    projectBisproNumber?: string | null;
    organizationBisproNumber?: string | null;
    projectPhaseName?: string | null;
    propertyTypeId?: string | null;
    propertyTypeName?: string | null;
    apartmentBuildingId?: string | null;
    identifier?: string | null;
    serviceCostsPerMonth?: number;
    security?: number | null;
    wishlistItemCount?: number;
    numberOfReserveCandidates?: number;
    availabilityStatus?: ConstructionNumberStatus;
    shortDescription?: string | null;
    longDescription?: string | null;
    houseSubType?: string | null;
    deliveryDate?: string | null;
    geometry?: PolygonModel[] | null;
    resources?: ResourceModel[] | null;
    groundLease?: GroundLease;
    mainImage?: ResourceModel;
    specifications?: ConstructionNumberSpecifications;
    salesPrice?: PropertySalesPrice;
    rentalPrice?: PropertyRentalPrice;
    landRegistration?: LandRegistrationDetails;
    extraSpecifications?: ExtraSpecifications;
    isEnergyNeutral?: boolean;
    numberOfFloors?: number | null;
    mainFloorNumber?: string | null;
    floors?: Floor[] | null;
    gardens?: GardenModel[] | null;
    outsideSpace?: OutsideSpaceModel[] | null;
    outbuildings?: Outbuilding[] | null;
    id: string;
}

export interface ConstructionNumberSpecifications {
    nonLivingArea?: DecimalRange;
    buildingRelatedExternalSpace?: DecimalRange;
    externalStorage?: DecimalRange;
    characteristic?: string | null;
    sunDirection?: string | null;
    rooms?: DecimalRange;
    bedrooms?: DecimalRange;
    livingArea?: DecimalRange;
    livingRoomArea?: DecimalRange;
    plotArea?: DecimalRange;
    volume?: DecimalRange;
}

export type ConstructionNumberStatus = 'Available' | 'InOption' | 'Sold' | 'Reserved';

export interface CountryModel {
    isoCode?: string | null;
    name?: string | null;
    englishName?: string | null;
    seoText?: SeoText;
    id: string;
}

export interface CountryQuery {
    [key: string]: any;
}

export interface CustomerJourneyMilestone {
    type?: CustomerJourneyMilestoneType;
    date?: string;
    nodeId?: string | null;
    url?: string | null;
}

export type CustomerJourneyMilestoneType =
    | 'None'
    | 'NewPhaseAnnouncement'
    | 'SalesProcess'
    | 'ConceptAi'
    | 'ConstructionNumbersOnline'
    | 'FinalImages'
    | 'FinalPrices'
    | 'StartSaleAnnouncement'
    | 'WhatsIncluded'
    | 'StartSale'
    | 'ConstructionAwarded';

export interface DecimalRange {
    from?: number;
    to?: number | null;
}

export interface DigitalBrochureModel {
    dateCreated?: string;
    data?: string | null;
    pageUrl?: string | null;
    id: string;
}

export interface DigitalBrochureRequestModel {
    projectId?: string | null;
    areaId?: string | null;
    propertyId?: string | null;
    constructionNumberId?: string | null;
    firstName?: string | null;
    sufix?: string | null;
    lastName?: string | null;
    email?: string | null;
    data?: string | null;
    pageUrl?: string | null;
    documentName?: string | null;
}

export interface DistrictModel {
    areaProjectId?: string | null;
    name?: string | null;
    url?: string | null;
    location?: number[] | null;
    geometry?: PolygonModel[] | null;
    isSold?: boolean;
    enableWishlist?: boolean;
    descriptionTitle?: string | null;
    description?: string | null;
    image?: ResourceModel;
    id: string;
}

export interface DocumentModel {
    projectBisproNumber?: string | null;
    filename?: string | null;
    publicationDate?: string | null;
    title?: string | null;
    contentType?: string | null;
    documentType?: string | null;
    documentSubtype?: string | null;
    constructionBisproNumbers?: string[] | null;
    organizationBisproNumber?: string | null;
    isConcept?: boolean;
    url?: string | null;
    id: string;
}

export interface DynamicFormModel {
    objectName?: string | null;
    mailTo?: string | null;
    fields?: {
        [key: string]: string | null;
    } | null;
}

export interface ExtraSpecifications {
    quality?: string | null;
    isPermanentResidence?: boolean | null;
    isRecreationalResidence?: boolean | null;
    isInPark?: boolean | null;
    isPractice?: boolean | null;
    hasExternalStorage?: boolean | null;
    hasVveChecklist?: boolean | null;
    hasOpenPorch?: boolean | null;
    location?: string[] | null;
    certifications?: string[] | null;
    hotWater?: string[] | null;
    facilities?: string[] | null;
    isolation?: string[] | null;
    heating?: string[] | null;
    cooling?: string[] | null;
    energyPerformance?: string[] | null;
    remarks?: string[] | null;
    additionalConditions?: string[] | null;
    roofMaterial?: string | null;
    roofType?: string | null;
    roofRemarks?: string | null;
    energyLabel?: string | null;
    maintenanceInside?: string | null;
    maintenanceOutside?: string | null;
    vve?: Vve;
}

export interface Feature {
    type: GeoJSONObjectType;
    id?: string | null;
    geometry: IGeometryObject;
    properties: { [key: string]: any } | null;
    bbox?: number[] | null;
    crs?: ICRSObject;
}

export interface FeatureCollection {
    type: GeoJSONObjectType;
    features: Feature[];
    bbox?: number[] | null;
    crs?: ICRSObject;
}

export interface Floor {
    name?: string | null;
    type?: string | null;
    floorNumber?: string | null;
    totalNumberOfRooms?: number | null;
    totalNumberOfBedrooms?: number | null;
    rooms?: Room[] | null;
    id?: string | null;
    dbCreateTimestamp?: number | null;
    dbUpdateTimestamp?: number | null;
}

export interface FloorLight {
    name?: string | null;
    type?: string | null;
    floorNumber?: string | null;
}

export interface GardenLight {
    type?: string | null;
    position?: string | null;
    size?: number | null;
    hasBackEntrance?: boolean | null;
    isMain?: boolean;
}

export interface GardenModel {
    id?: string | null;
    type?: string | null;
    position?: string | null;
    length?: number | null;
    width?: number | null;
    area?: number | null;
    hasBackEntrance?: boolean | null;
    isMain?: boolean;
}

export type GeoJSONObjectType =
    | 'Point'
    | 'MultiPoint'
    | 'LineString'
    | 'MultiLineString'
    | 'Polygon'
    | 'MultiPolygon'
    | 'GeometryCollection'
    | 'Feature'
    | 'FeatureCollection';

export interface GrantModel {
    displayOnMap?: boolean;
    projectName?: string | null;
    cityName?: string | null;
    location?: number[] | null;
    status?: GrantStatus;
    id: string;
}

export type GrantStatus = 'NotActive' | 'ApplicationGranted';

export interface GroundLease {
    priceWithCanonDecimal?: number | null;
    canonPercentageYearly?: number | null;
    canonAmountYearlyDecimal?: number | null;
    canonPercentage10Year?: number | null;
    canonAmount10YearDecimal?: number | null;
    canonPercentage25Year?: number | null;
    canonAmount25YearDecimal?: number | null;
    buyOffAmountDecimal?: number | null;
    priceWithBuyOffDecimal?: number | null;
}

export type HolidayFrequency = 'Once' | 'Monthly' | 'Yearly';

export interface HouseSelectorModel {
    areaProjectId?: string | null;
    districtId?: string | null;
    displayName?: string | null;
    alias?: string | null;
    nodeId?: string | null;
    views?: HouseSelectorView[] | null;
    id: string;
}

export interface HouseSelectorObject {
    objectType?: string | null;
    objectId?: string | null;
    point?: Point;
    polygon?: Point[] | null;
    linkToViewId?: string | null;
    label?: string | null;
    url?: string | null;
    iconName?: string | null;
}

export interface HouseSelectorView {
    id?: string | null;
    name?: string | null;
    imageUrl?: string | null;
    imageMediaId?: number;
    objects?: HouseSelectorObject[] | null;
}

export interface ICRSObject {
    type?: CRSType;
}

export interface IGeometryObject {
    type?: GeoJSONObjectType;
}

export interface LandRegistrationDetails {
    name?: string | null;
    proportion?: string | null;
    purchaseOption?: boolean | null;
    dateOfRequest?: string | null;
    durationOfLeaseHold?: string | null;
    isPermanentlyBought?: boolean | null;
    leaseHoldProvider?: string | null;
    leaseHoldPerYear?: number | null;
    cityHall?: string | null;
    municipalityId?: string | null;
    municipalityCode?: string | null;
    number?: string | null;
    scope?: string | null;
    area?: number | null;
    section?: string | null;
    type?: string | null;
    fixedVariable?: string | null;
    propertyTypeType?: string | null;
    propertyType?: string | null;
    plot?: string | null;
    constructionNumberId?: string | null;
    id?: string | null;
    dbCreateTimestamp?: number | null;
    dbUpdateTimestamp?: number | null;
}

export interface LeadFormModel {
    projectId?: string | null;
    propertyTypeId?: string | null;
    constructionNumberId?: string | null;
    areaProjectId?: string | null;
    districtId?: string | null;
    leadSource?: string | null;
    referringUrl?: string | null;
    salutation?: Salutation;
    initials?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    lastNamePrefix?: string | null;
    street?: string | null;
    houseNumber?: string | null;
    houseNumberAddition?: string | null;
    postalCode?: string | null;
    city?: string | null;
    phone?: string | null;
    mobilePhone?: string | null;
    email?: string | null;
    countryId?: string | null;
    brochureId?: string | null;
    comment?: string | null;
    intendedUsage?: string | null;
    purchaseTimeframe?: string | null;
    financialCheck?: string | null;
}

export interface OpeningHours {
    name?: string | null;
    isActive?: boolean;
    isDefault?: boolean;
    monday?: TimeRange;
    tuesday?: TimeRange;
    wednesday?: TimeRange;
    thursday?: TimeRange;
    friday?: TimeRange;
    saturday?: TimeRange;
    sunday?: TimeRange;
    holidays?: OpeningHoursHoliday[] | null;
    id?: string | null;
    dbCreateTimestamp?: number | null;
    dbUpdateTimestamp?: number | null;
}

export interface OpeningHoursHoliday {
    name?: string | null;
    startDate?: string;
    endDate?: string | null;
    openingHours?: TimeRange;
    frequency?: HolidayFrequency;
}

export interface Outbuilding {
    typeCode?: string | null;
    name?: string | null;
    geometry?: FeatureCollection;
    type?: string | null;
    outbuildingType?: string | null;
    length?: number | null;
    width?: number | null;
    area?: number | null;
    isolation?: string[] | null;
    facilities?: string[] | null;
    facilitiesRemarks?: string | null;
    situation?: string | null;
    capacity?: number | null;
    id?: string | null;
    dbCreateTimestamp?: number | null;
    dbUpdateTimestamp?: number | null;
}

export interface OutsideSpaceModel {
    id?: string | null;
    type?: string | null;
    position?: string | null;
    length?: number | null;
    width?: number | null;
    area?: number | null;
    hasBackEntrance?: boolean | null;
}

export interface PipelineProjectModel {
    name?: string | null;
    status?: PipelineProjectStatus;
    isActive?: boolean;
    cityName?: string | null;
    location?: number[] | null;
    image?: ResourceModel;
    id: string;
}

export interface PipelineProjectQuery {
    [key: string]: any;
}

export type PipelineProjectStatus =
    | 'InPreparation'
    | 'UnderConstruction'
    | 'Finished'
    | 'SoonForRent'
    | 'ForRent'
    | 'Rented';

export interface Point {
    x?: number;
    y?: number;
}

export interface PolygonModel {
    coordinates?: number[][] | null;
}

export type PriceCondition = 'VrijOpNaam' | 'KostenKoper';

export type PriceType =
    | 'ExactSum'
    | 'AskingPrice'
    | 'StartsFrom'
    | 'Indication'
    | 'Circa'
    | 'PriceOnRequest';

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
}

export interface ProjectModel {
    id?: string | null;
    name?: string | null;
    cityName?: string | null;
    fundaStatus?: string | null;
    fundaLastSyncDate?: string | null;
    fundaGatewayTransactionId?: number | null;
    fundaId?: number | null;
    connectionVersion?: string | null;
    userType?: string | null;
    gwnProjectVersion?: string | null;
    isAdmin?: boolean;
}

export interface ProjectPhaseModel {
    areaProjectId?: string | null;
    bisproNumber?: string | null;
    organisationBisproNumber?: string | null;
    areaProjectName?: string | null;
    districtId?: string | null;
    name?: string | null;
    url?: string | null;
    districtUrl?: string | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    status?: ProjectPhaseStatus;
    estimatedSaleStartDate?: string | null;
    saleStartDate?: string | null;
    saleEndDate?: string | null;
    allocationDate?: string | null;
    awardDate?: string | null;
    cityName?: string | null;
    municipalityName?: string | null;
    provinceName?: string | null;
    sortIndex?: number | null;
    environmentTypes?: string[] | null;
    deliveryStartDate?: string | null;
    constructionStartDate?: string | null;
    isRental?: boolean;
    isDigitalBrochureEnabled?: boolean;
    isNewDocumentsEnabled?: boolean;
    indicationServiceCosts?: number | null;
    indicationSecurity?: number | null;
    location?: number[] | null;
    geometry?: PolygonModel[] | null;
    resources?: ResourceModel[] | null;
    mainImage?: ResourceModel;
    propertySpecifications?: PropertySpecifications;
    propertyPurchasePrice?: PropertySalesPrice;
    propertyRentalPrice?: PropertyRentalPrice;
    houseTypes?: string[] | null;
    customerJourneyMilestones?: CustomerJourneyMilestone[] | null;
    id: string;
}

export type ProjectPhaseStatus =
    | 'InPreparation'
    | 'OnSale'
    | 'Sold'
    | 'ForRent'
    | 'Rented'
    | 'NotActive';

export interface PropertyLight {
    id?: string | null;
    projectId?: string | null;
    areaId?: string | null;
    name?: string | null;
    description?: string | null;
    salesPriceFrom?: number | null;
    salesPriceTo?: number | null;
    livingAreaFrom?: number | null;
    livingAreaTo?: number | null;
    lotAreaFrom?: number | null;
    lotAreaTo?: number | null;
    volumeFrom?: number | null;
    volumeTo?: number | null;
    numberOfRoomsFrom?: number | null;
    numberOfRoomsTo?: number | null;
    numberOfBedroomsFrom?: number | null;
    numberOfBedroomsTo?: number | null;
    imageUrl?: string | null;
    url?: string | null;
}

export interface PropertyRentalPrice {
    deposit?: number | null;
    amount?: DecimalRange;
    priceType?: PriceType;
    priceTypeFunda?: string | null;
    monthlyServiceCosts?: number | null;
}

export interface PropertySalesPrice {
    condition?: PriceCondition;
    saleSpecification?: SaleSpecification;
    amount?: DecimalRange;
    priceType?: PriceType;
    priceTypeFunda?: string | null;
    monthlyServiceCosts?: number | null;
}

export interface PropertySpecifications {
    rooms?: DecimalRange;
    bedrooms?: DecimalRange;
    livingArea?: DecimalRange;
    livingRoomArea?: DecimalRange;
    plotArea?: DecimalRange;
    volume?: DecimalRange;
}

export interface PropertyTypeModel {
    areaProjectId?: string | null;
    districtId?: string | null;
    projectPhaseId?: string | null;
    projectPhaseName?: string | null;
    name?: string | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    houseType?: string | null;
    houseSubType?: string | null;
    sortIndex?: number | null;
    environmentTypes?: string[] | null;
    hasBalcony?: boolean;
    isRental?: boolean;
    groundLease?: GroundLease;
    geometry?: PolygonModel[] | null;
    resources?: ResourceModel[] | null;
    mainImage?: ResourceModel;
    deliveryStartDate?: string | null;
    constructionStartDate?: string | null;
    indicationServiceCosts?: number | null;
    indicationSecurity?: number | null;
    specifications?: PropertySpecifications;
    salesPrice?: PropertySalesPrice;
    rentalPrice?: PropertyRentalPrice;
    canShowPrice?: boolean;
    extraSpecifications?: ExtraSpecifications;
    numberOfFloors?: number | null;
    mainFloorNumber?: string | null;
    floors?: Floor[] | null;
    gardens?: GardenModel[] | null;
    outsideSpace?: OutsideSpaceModel[] | null;
    outbuildings?: Outbuilding[] | null;
    usp1Title?: string | null;
    usp1Text?: string | null;
    usp2Title?: string | null;
    usp2Text?: string | null;
    id: string;
}

export interface ProvinceModel {
    countryId?: string | null;
    countryIsoCode?: string | null;
    name?: string | null;
    seoText?: SeoText;
    id: string;
}

export interface RegionModel {
    name?: string | null;
    id: string;
}

export interface ResourceModel {
    title?: string | null;
    url?: string | null;
    resourceType?: string | null;
    contentType?: string | null;
    mediaNodeId?: string | null;
    lastUpdatedUtc?: string;
    metadata?: {
        [key: string]: string | null;
    } | null;
}

export interface ResourceReference {
    ownerId?: string | null;
    ownerType?: string | null;
    isMainResource?: boolean | null;
}

export interface Room {
    name?: string | null;
    type?: string | null;
    hasStairs?: boolean | null;
    length?: number | null;
    width?: number | null;
    height?: number | null;
    area?: number | null;
    volume?: number | null;
    renewedIn?: string | null;
    facilities?: string[] | null;
}

export type SaleSpecification = 'ExclusiefBouwrente' | 'BtwBelast' | 'InclusiefBtw';

export type Salutation = 'Undefined' | 'Mr' | 'Mrs' | 'Ms';

export interface SeoText {
    saleTitle?: string | null;
    saleText?: string | null;
    rentalTitle?: string | null;
    rentalText?: string | null;
}

export interface Time {
    hour?: number;
    minute?: number;
}

export interface TimeRange {
    from?: Time;
    to?: Time;
}

export interface UpdateApartmentBuildingModel {
    districtId?: string | null;
    alias?: string | null;
    displayName?: string | null;
    description?: string | null;
    propertyTypeIds?: string[] | null;
    sortIndex?: number;
    views?: ApartmentBuildingView[] | null;
    image?: UpdateResourceModel;
}

export interface UpdateHouseSelectorBaseModel {
    districtId?: string | null;
    displayName?: string | null;
    description?: string | null;
    alias?: string | null;
}

export interface UpdateHouseSelectorViewsModel {
    views?: HouseSelectorView[] | null;
}

export interface UpdateResourceModel {
    title?: string | null;
    url?: string | null;
    resourceType?: string | null;
    contentType?: string | null;
    sortIndex?: number;
    references?: ResourceReference[] | null;
    metadata?: {
        [key: string]: string | null;
    } | null;
}

export interface Vve {
    vveContribution?: number | null;
    hasMaintenanceForecast?: boolean | null;
    hasPeriodicContribution?: boolean | null;
    isRegisteredInKvK?: boolean | null;
    hasHomeInsurance?: boolean | null;
    hasReserveFunds?: boolean | null;
    hasMeetings?: boolean | null;
}

export type WebchatType = 'None' | 'UnifiedCommunications' | 'Salesforce';

export interface WebsiteContactModel {
    enableWebchat?: boolean;
    webchatType?: WebchatType;
    webchatServer?: string | null;
    webchatUcc?: string | null;
    webchatChannelMenuName?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    facebookUrl?: string | null;
    pinterestUrl?: string | null;
    twitterUrl?: string | null;
    caseViaEmail?: boolean;
    openingHours?: OpeningHours;
}

export interface WebsiteModel {
    mapboxTilesetId?: string | null;
    mapboxDatasetId?: string | null;
    url?: string | null;
    disablePropertyComparison?: boolean;
    enableCustomerCommunity?: boolean;
    enableFavourites?: boolean;
    enableMortgageCalculator?: boolean;
    secondLevelNavigationLabelSingular?: string | null;
    secondLevelNavigationLabelPlural?: string | null;
    skinName?: string | null;
    contactDetails?: WebsiteContactModel;
    showOnCorporateSite?: boolean;
    isMyEnvironmentIframeEnabled?: boolean;
    isNewDocumentsEnabled?: boolean;
}

export interface ActivationEngineGetProfileQueryParams {
    areaId?: string;
    projectId?: string;
}

export interface ApartmentBuildingQueryQueryParams {
    AreaProjectId?: string;
    ProjectPhaseId?: string;
    include?: string;
    lang?: string;
}

export interface ApartmentBuildingUpdateApartmentBuildingQueryParams {
    apiKey?: string;
    origin?: string;
}

export interface ApartmentBuildingDeleteApartmentBuildingQueryParams {
    apiKey?: string;
    origin?: string;
}

export interface ApartmentBuildingGetByExternalIdQueryParams {
    include?: string;
    lang?: string;
}

export interface AreaProjectGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface AreaProjectQueryQueryParams {
    CountryIsoCode?: string;
    HasLocationData?: boolean;
    CorporateSite?: boolean;
    include?: string;
    lang?: string;
}

export interface CityGetByNameQueryParams {
    include?: string;
    lang?: string;
}

export interface CityGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface CityQueryQueryParams {
    CountryIsoCode?: string;
    include?: string;
    lang?: string;
}

export interface ConstructionNumberGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface ConstructionNumberQueryQueryParams {
    AreaProjectId?: string;
    DistrictId?: string;
    ProjectPhaseId?: string;
    PropertyTypeId?: string;
    MinPrice?: number;
    MaxPrice?: number;
    IncludeInactive?: boolean;
    include?: string;
    lang?: string;
}

export interface CountryGetByIsoCodeQueryParams {
    include?: string;
    lang?: string;
}

export interface CountryGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface CountryQueryQueryParams {
    query?: CountryQuery;
    include?: string;
    lang?: string;
}

export interface DistrictGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface DistrictQueryQueryParams {
    AreaProjectId?: string;
    include?: string;
    lang?: string;
}

export interface DocumentGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface DocumentQueryQueryParams {
    OrganizationBisproNumber?: string;
    ProjectBisproNumber?: string;
    ProjectBisproNumbers?: string;
    ConstructionBisproNumbers?: string;
    include?: string;
    lang?: string;
}

export interface FundaQueryQueryParams {
    apiKey?: string;
    regionId?: string;
    query?: string;
    userType?: string;
    isAdmin?: boolean;
    allowedRegionIds?: string;
}

export interface FundaGetQueryParams {
    apiKey?: string;
    id?: string;
    isAdmin?: boolean;
    userType?: string;
}

export interface FundaSubmitQueryParams {
    apiKey?: string;
    id?: string;
    incrementVersion?: boolean;
}

export interface FundaSubmitRouteQueryParams {
    apiKey?: string;
    incrementVersion?: boolean;
}

export interface FundaRunTransactionCheckQueryParams {
    apiKey?: string;
}

export interface FundaValidateQueryParams {
    apiKey?: string;
    id?: string;
}

export interface FundaShowLastSubmittedProjectQueryParams {
    apiKey?: string;
    projectCrmId?: string;
}

export interface FundaShowConvertedFundaObjectQueryParams {
    apiKey?: string;
    projectCrmId?: string;
}

export interface FundaCompareFundaObjectRevisionChangesQueryParams {
    apiKey?: string;
    projectCrmId?: string;
    gwnId?: number;
}

export interface FundaShowFundaProjectLogsQueryParams {
    apiKey?: string;
    projectCrmId?: string;
}

export interface FundaExecuteFundaPublisherQueryParams {
    apiKey?: string;
}

export interface FundaGetAllGwnVersionsByProjectIdQueryParams {
    apiKey?: string;
    projectCrmId?: string;
}

export interface FundaRemoveVersionFromGwnQueryParams {
    apiKey?: string;
    projectId?: string;
    projectFundaId?: number;
    projectCode?: string;
    nvmId?: string;
}

export interface FundaGetActiveBrokersInGatewayQueryParams {
    apiKey?: string;
}

export interface GrantGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface GrantQueryQueryParams {
    ProjectName?: string;
    include?: string;
    lang?: string;
}

export interface HouseSelectorQueryQueryParams {
    AreaProjectId?: string;
    DistrictId?: string;
    include?: string;
    lang?: string;
}

export interface HouseSelectorUpdateHouseSelectorQueryParams {
    apiKey?: string;
}

export interface HouseSelectorDeleteHouseSelectorQueryParams {
    apiKey?: string;
    deleteDraft?: boolean;
}

export interface HouseSelectorGetByExternalIdQueryParams {
    include?: string;
    lang?: string;
}

export interface HouseSelectorPublishHouseSelectorQueryParams {
    apiKey?: string;
}

export interface HouseSelectorUpdateHouseSelectorViewsQueryParams {
    apiKey?: string;
}

export interface HouseSelectorGetDraftByExternalIdQueryParams {
    apiKey?: string;
    lang?: string;
}

export interface PipelineProjectGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface PipelineProjectQueryQueryParams {
    query?: PipelineProjectQuery;
    include?: string;
    lang?: string;
}

export interface ProjectPhaseGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface ProjectPhaseQueryQueryParams {
    CountryIsoCode?: string;
    AreaProjectId?: string;
    IncludeInactive?: boolean;
    include?: string;
    lang?: string;
}

export interface PropertyTypeGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface PropertyTypeQueryQueryParams {
    AreaProjectId?: string;
    DistrictId?: string;
    ProjectPhaseId?: string;
    IncludeInactive?: boolean;
    include?: string;
    lang?: string;
}

export interface ProvinceGetByNameQueryParams {
    include?: string;
    lang?: string;
}

export interface ProvinceGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface ProvinceQueryQueryParams {
    CountryIsoCode?: string;
    include?: string;
    lang?: string;
}

export interface RegionGetByIdQueryParams {
    include?: string;
    lang?: string;
}

export interface RegionQueryQueryParams {
    AllowedRegionIds?: string;
    include?: string;
    lang?: string;
}

export interface ResourceUpdateResourceQueryParams {
    apiKey?: string;
    projectId?: string;
}

export interface ResourceDeleteResourceQueryParams {
    apiKey?: string;
    projectId?: string;
}

export const activationEngineGetProfile = (
    clientId: string,
    params?: ActivationEngineGetProfileQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<ActivationEngineModel>(
        `/activationengine/profile/${clientId}`,
        params,
        config,
    ).then((res) => res!);

export const apartmentBuildingQuery = (
    params?: ApartmentBuildingQueryQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<ApartmentBuildingModel[]>(`/apartmentbuildings`, params, config).then(
        (res) => res!,
    );

export const apartmentBuildingUpdateApartmentBuilding = (
    nodeId: string,
    body: UpdateApartmentBuildingModel,
    config?: RequestConfig,
) => APIClient.put<void>(`/apartmentbuildings/${nodeId}`, body, config).then((res) => res!);

export const apartmentBuildingDeleteApartmentBuilding = (
    nodeId: string,
    body: any,
    config?: RequestConfig,
) => APIClient.delete<void>(`/apartmentbuildings/${nodeId}`, body, config).then((res) => res!);

export const apartmentBuildingGetByExternalId = (
    nodeId: string,
    params?: ApartmentBuildingGetByExternalIdQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<ApartmentBuildingModel>(`/apartmentbuildings/${nodeId}`, params, config).then(
        (res) => res!,
    );

export const areaProjectGetById = (
    id: string,
    params?: AreaProjectGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<AreaProjectModel>(`/areaprojects/${id}`, params, config).then((res) => res!);

export const areaProjectQuery = (params?: AreaProjectQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<AreaProjectModel[]>(`/areaprojects`, params, config).then((res) => res!);

export const cityGetByName = (
    name: string,
    params?: CityGetByNameQueryParams,
    config?: RequestConfig,
) => APIClient.get<CityModel>(`/cities/name/${name}`, params, config).then((res) => res!);

export const cityGetById = (id: string, params?: CityGetByIdQueryParams, config?: RequestConfig) =>
    APIClient.get<CityModel>(`/cities/${id}`, params, config).then((res) => res!);

export const cityQuery = (params?: CityQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<CityModel[]>(`/cities`, params, config).then((res) => res!);

export const constructionNumberGetById = (
    id: string,
    params?: ConstructionNumberGetByIdQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<ConstructionNumberModel>(`/constructionnumbers/${id}`, params, config).then(
        (res) => res!,
    );

export const constructionNumberQuery = (
    params?: ConstructionNumberQueryQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<ConstructionNumberModel[]>(`/constructionnumbers`, params, config).then(
        (res) => res!,
    );

export const constructionNumberGet = (
    projectId: string,
    constructionNumber: string,
    params?: any,
    config?: RequestConfig,
) =>
    APIClient.get<ConstructionNumberLight>(
        `/light/projects/${projectId}/constructionnumbers/${constructionNumber}`,
        params,
        config,
    ).then((res) => res!);

export const constructionNumberList = (projectId: string, params?: any, config?: RequestConfig) =>
    APIClient.get<ConstructionNumberLight>(
        `/light/projects/${projectId}/constructionnumbers`,
        params,
        config,
    ).then((res) => res!);

export const countryGetByIsoCode = (
    isoCode: string,
    params?: CountryGetByIsoCodeQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<CountryModel>(`/countries/isoCode/${isoCode}`, params, config).then(
        (res) => res!,
    );

export const countryGetById = (
    id: string,
    params?: CountryGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<CountryModel>(`/countries/${id}`, params, config).then((res) => res!);

export const countryQuery = (params?: CountryQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<CountryModel[]>(`/countries`, params, config).then((res) => res!);

export const digitalBrochureGetById = (id: string, params?: any, config?: RequestConfig) =>
    APIClient.get<DigitalBrochureModel>(`/digital-brochures/${id}`, params, config).then(
        (res) => res!,
    );

export const districtGetById = (
    id: string,
    params?: DistrictGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<DistrictModel>(`/districts/${id}`, params, config).then((res) => res!);

export const districtQuery = (params?: DistrictQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<DistrictModel[]>(`/districts`, params, config).then((res) => res!);

export const documentGetById = (
    id: string,
    params?: DocumentGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<DocumentModel>(`/documents/${id}`, params, config).then((res) => res!);

export const documentQuery = (params?: DocumentQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<DocumentModel[]>(`/documents`, params, config).then((res) => res!);

export const formLead = (body: LeadFormModel, config?: RequestConfig) =>
    APIClient.post<void>(`/forms/lead`, body, config).then((res) => res!);

export const formCase = (body: CaseFormModel, config?: RequestConfig) =>
    APIClient.post<void>(`/forms/case`, body, config).then((res) => res!);

export const formDynamic = (body: DynamicFormModel, config?: RequestConfig) =>
    APIClient.post<void>(`/forms/dynamic`, body, config).then((res) => res!);

export const formDigitalBrochure = (body: DigitalBrochureRequestModel, config?: RequestConfig) =>
    APIClient.post<void>(`/forms/digital-brochure`, body, config).then((res) => res!);

export const fundaQuery = (params?: FundaQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<ProjectModel[]>(`/funda/query`, params, config).then((res) => res!);

export const fundaGet = (params?: FundaGetQueryParams, config?: RequestConfig) =>
    APIClient.get<void>(`/funda`, params, config).then((res) => res!);

export const fundaSubmit = (body: any, config?: RequestConfig) =>
    APIClient.post<void>(`/funda/submit`, body, config).then((res) => res!);

export const fundaSubmitRoute = (id: string, body: any, config?: RequestConfig) =>
    APIClient.post<void>(`/funda/submit/${id}`, body, config).then((res) => res!);

export const fundaRunTransactionCheck = (
    params?: FundaRunTransactionCheckQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/check`, params, config).then((res) => res!);

export const fundaValidate = (body: any, config?: RequestConfig) =>
    APIClient.post<void>(`/funda/validate`, body, config).then((res) => res!);

export const fundaShowLastSubmittedProject = (
    params?: FundaShowLastSubmittedProjectQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/ShowLastSubmittedProject`, params, config).then((res) => res!);

export const fundaShowConvertedFundaObject = (
    params?: FundaShowConvertedFundaObjectQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/ShowConvertedFundaObject`, params, config).then((res) => res!);

export const fundaCompareFundaObjectRevisionChanges = (
    params?: FundaCompareFundaObjectRevisionChangesQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<void>(`/funda/CompareFundaObjectRevisionChanges`, params, config).then(
        (res) => res!,
    );

export const fundaShowFundaProjectLogs = (
    params?: FundaShowFundaProjectLogsQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/ShowFundaProjectLogs`, params, config).then((res) => res!);

export const fundaExecuteFundaPublisher = (
    params?: FundaExecuteFundaPublisherQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/ExecuteFundaPublisher`, params, config).then((res) => res!);

export const fundaGetAllGwnVersionsByProjectId = (
    params?: FundaGetAllGwnVersionsByProjectIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/GetAllGwnVersionsByProjectId`, params, config).then((res) => res!);

export const fundaRemoveVersionFromGwn = (
    params?: FundaRemoveVersionFromGwnQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/RemoveVersionFromGwn`, params, config).then((res) => res!);

export const fundaGetActiveBrokersInGateway = (
    params?: FundaGetActiveBrokersInGatewayQueryParams,
    config?: RequestConfig,
) => APIClient.get<void>(`/funda/GetActiveBrokersInGateway`, params, config).then((res) => res!);

export const grantGetById = (
    id: string,
    params?: GrantGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<GrantModel>(`/grants/${id}`, params, config).then((res) => res!);

export const grantQuery = (params?: GrantQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<GrantModel[]>(`/grants`, params, config).then((res) => res!);

export const houseSelectorQuery = (
    params?: HouseSelectorQueryQueryParams,
    config?: RequestConfig,
) => APIClient.get<HouseSelectorModel[]>(`/houseselectors`, params, config).then((res) => res!);

export const houseSelectorUpdateHouseSelector = (
    nodeId: string,
    body: UpdateHouseSelectorBaseModel,
    config?: RequestConfig,
) => APIClient.put<void>(`/houseselectors/${nodeId}`, body, config).then((res) => res!);

export const houseSelectorDeleteHouseSelector = (
    nodeId: string,
    body: any,
    config?: RequestConfig,
) => APIClient.delete<void>(`/houseselectors/${nodeId}`, body, config).then((res) => res!);

export const houseSelectorGetByExternalId = (
    nodeId: string,
    params?: HouseSelectorGetByExternalIdQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<HouseSelectorModel>(`/houseselectors/${nodeId}`, params, config).then(
        (res) => res!,
    );

export const houseSelectorPublishHouseSelector = (
    nodeId: string,
    body: any,
    config?: RequestConfig,
) => APIClient.put<void>(`/houseselectors/${nodeId}/publish`, body, config).then((res) => res!);

export const houseSelectorUpdateHouseSelectorViews = (
    nodeId: string,
    body: UpdateHouseSelectorViewsModel,
    config?: RequestConfig,
) => APIClient.put<void>(`/houseselectors/${nodeId}/views`, body, config).then((res) => res!);

export const houseSelectorGetDraftByExternalId = (
    nodeId: string,
    params?: HouseSelectorGetDraftByExternalIdQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<HouseSelectorModel>(`/houseselectors/${nodeId}/draft`, params, config).then(
        (res) => res!,
    );

export const pipelineProjectGetById = (
    id: string,
    params?: PipelineProjectGetByIdQueryParams,
    config?: RequestConfig,
) =>
    APIClient.get<PipelineProjectModel>(`/pipelineprojects/${id}`, params, config).then(
        (res) => res!,
    );

export const pipelineProjectQuery = (
    params?: PipelineProjectQueryQueryParams,
    config?: RequestConfig,
) => APIClient.get<PipelineProjectModel[]>(`/pipelineprojects`, params, config).then((res) => res!);

export const projectPhaseSetCustomerJourneyMilestone = (
    id: string,
    body: CustomerJourneyMilestone,
    config?: RequestConfig,
) => APIClient.put<void>(`/projectphases/${id}/milestone`, body, config).then((res) => res!);

export const projectPhaseDeleteCustomerJourneyMilestone = (
    id: string,
    nodeId: string,
    body: any,
    config?: RequestConfig,
) =>
    APIClient.delete<void>(`/projectphases/${id}/milestone/${nodeId}`, body, config).then(
        (res) => res!,
    );

export const projectPhaseGetById = (
    id: string,
    params?: ProjectPhaseGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<ProjectPhaseModel>(`/projectphases/${id}`, params, config).then((res) => res!);

export const projectPhaseQuery = (params?: ProjectPhaseQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<ProjectPhaseModel[]>(`/projectphases`, params, config).then((res) => res!);

export const propertyGetPublicProperties = (params?: any, config?: RequestConfig) =>
    APIClient.get<PropertyLight>(`/light/properties`, params, config).then((res) => res!);

export const propertyList = (projectId: string, params?: any, config?: RequestConfig) =>
    APIClient.get<PropertyLight>(`/light/projects/${projectId}/properties`, params, config).then(
        (res) => res!,
    );

export const propertyTypeGetById = (
    id: string,
    params?: PropertyTypeGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<PropertyTypeModel>(`/propertytypes/${id}`, params, config).then((res) => res!);

export const propertyTypeQuery = (params?: PropertyTypeQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<PropertyTypeModel[]>(`/propertytypes`, params, config).then((res) => res!);

export const provinceGetByName = (
    name: string,
    params?: ProvinceGetByNameQueryParams,
    config?: RequestConfig,
) => APIClient.get<ProvinceModel>(`/provinces/name/${name}`, params, config).then((res) => res!);

export const provinceGetById = (
    id: string,
    params?: ProvinceGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<ProvinceModel>(`/provinces/${id}`, params, config).then((res) => res!);

export const provinceQuery = (params?: ProvinceQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<ProvinceModel[]>(`/provinces`, params, config).then((res) => res!);

export const regionGetById = (
    id: string,
    params?: RegionGetByIdQueryParams,
    config?: RequestConfig,
) => APIClient.get<RegionModel>(`/region/${id}`, params, config).then((res) => res!);

export const regionQuery = (params?: RegionQueryQueryParams, config?: RequestConfig) =>
    APIClient.get<RegionModel[]>(`/region`, params, config).then((res) => res!);

export const resourceUpdateResource = (
    mediaId: string,
    body: UpdateResourceModel,
    config?: RequestConfig,
) => APIClient.put<void>(`/resources/${mediaId}`, body, config).then((res) => res!);

export const resourceDeleteResource = (mediaId: string, body: any, config?: RequestConfig) =>
    APIClient.delete<void>(`/resources/${mediaId}`, body, config).then((res) => res!);
